import { useMemo } from "react";
import { Pagination } from "datastake-daf/dist/components";
import { MOBILE_W } from "datastake-daf/src/constants/Style";
import { useResizeContext } from "datastake-daf/dist/context";

export default function TablePagination({
  page = 0,
  totalPages = 0,
  goPrev = () => { },
  goNext = () => { },
  canGoNext = false,
  canGoPrev = false,
  loaded = true,
  totalItems,
  doTotalItems,
  perPage = 10,
  arrowIcons = false,
  onChangePagination,
  t = (s) => s,
}) {
  const { windowWidth } = useResizeContext();
  const isMobile = useMemo(() => windowWidth <= MOBILE_W, [windowWidth]);

  return (
    <Pagination
      page={page}
      totalPages={totalPages}
      goPrev={goPrev}
      goNext={goNext}
      canGoNext={canGoNext}
      isMobile={isMobile}
      canGoPrev={canGoPrev}
      loaded={loaded}
      totalItems={totalItems}
      doTotalItems={doTotalItems}
      perPage={perPage}
      arrowIcons={arrowIcons}
      onChangePagination={onChangePagination}
      t={t}
    />
  );
}
